import React from 'react';
import {Text} from "./styled/Text";
import {XLMediaQuery} from "./mediaquery/XLMediaQuery";
import {LMediaQuery} from "./mediaquery/LMediaQuery";
import {XSMediaQuery} from "./mediaquery/XSMediaQuery";
import {SMediaQuery} from "./mediaquery/SMediaQuery";
import {MMediaQuery} from "./mediaquery/MMediaQuery";

import {VerticalLayout} from "../layout/VerticalLayout";

interface FieldInterface {
    label: string;
    labelSize?: string;
    labelWeight?: number;
    fontSize?: string;
    fontWeight?: number;
    marginRight?: string;
    marginLeft?: string;
    color?: string;
    margin?: string;
    className?: string;
    render?: boolean;
}

const Field: React.FC<FieldInterface> = (props) => {
    const margin = props.margin ?? '5px';
    const fontSize = props.fontSize ?? '1rem';
    const fontWeight = props.fontWeight ?? 400;
    const labelSize = props.labelSize ?? '1.2em';
    const labelWeight = props.labelWeight ?? 400;
    const render = props.render ?? true;
    const xlsField = () => {
        return (
        <Text className={props.className} fontSize={fontSize} margin={margin}>
            <span style={{fontSize: labelSize, fontWeight: labelWeight, paddingRight: '10px'}}>{props.label}:</span>
            <span
                style={{fontSize: '1.2em', fontWeight: (props.fontWeight !== undefined ? props.fontWeight: 700), color: props.color}}
            >
                {props.children ?? <span style={{fontStyle: 'italic', color: 'lightgray'}}>Non Specificato</span>}
            </span>
        </Text>
        )
    };

    const smallField = () => {
        return (
            <VerticalLayout className={props.className} style={{fontSize: fontSize, margin: margin}}>
                <Text fontSize={'1.2em'} fontWeight={`${fontWeight}`} paddingRight={'10px'}>{props.label}:</Text>
                <Text
                    fontSize={'1.2em'}
                    fontWeight={props.fontWeight !== undefined ? `${props.fontWeight}`: '700'}
                    color={props.color}
                >
                    {props.children ?? <span style={{fontStyle: 'italic', color: 'lightgray'}}>Non Specificato</span>}
                </Text>
            </VerticalLayout>
        )
    }

    return (

        <>
            <XLMediaQuery>
                {render && xlsField()}
            </XLMediaQuery>
            <LMediaQuery>
                {render && xlsField()}
            </LMediaQuery>
            <MMediaQuery>
                {render && smallField()}
            </MMediaQuery>
            <XSMediaQuery>
                {render && smallField()}
            </XSMediaQuery>
            <SMediaQuery>
                {render && smallField()}
            </SMediaQuery>
        </>

    )
};
export default Field;